import { Box } from '@chakra-ui/react';
import { colors } from '@/theme/foundations/colors';
// @ts-expect-error -- interweave ships no type declarations
import { Interweave } from 'interweave';
import {
  ScorecardHistoryTable,
  SCORECARDS_DATA_ATTR,
  type ScorecardHistoryRow,
} from '@/components/ats/scorecard-history';

// Swap stored scorecard-history tables (recognised by the SCORECARDS_DATA_ATTR
// attribute generated in `generateScorecardTableHTML`) for the React component
// so the Activity column renders with a real Kula tooltip.
const hydrateScorecardTable = (node: HTMLElement) => {
  const payload = node.getAttribute?.(SCORECARDS_DATA_ATTR);
  if (!payload) return undefined;
  try {
    const scorecards = JSON.parse(
      decodeURIComponent(payload)
    ) as ScorecardHistoryRow[];
    return <ScorecardHistoryTable scorecards={scorecards} />;
  } catch {
    return undefined;
  }
};

export function RichText({ children }: { children: string }) {
  return <Interweave content={children} transform={hydrateScorecardTable} />;
}

export const HtmlRenderer = ({ htmlString, editorStyle = false, ...props }) => {
  return (
    <Box
      css={
        editorStyle
          ? `
        p {
          font-size: 14px;
          color: ${colors['secondary-700']};
        }

        h1,
        h2,
        h3,
        h4,
        h5 {
          font-size: revert;
          font-weight: 450;
          color: ${colors['secondary-800']};
          margin-block-start: 0.5rem;
          margin-block-end: 0.5rem;
        }

        ul,
        ol {
          font-size: 14px;
          margin-block-start: revert !important;
          margin-block-end: revert !important;
          margin-inline-start: revert !important;
          margin-inline-end: revert !important;
          padding-inline-start: revert !important;
        }

        a {
          color: ${colors['primary-500']};
          text-decoration: underline;
        }

        p:empty::after {
          content: '\u00A0';
        }

        h1 {
          font-size: 32px;
          line-height: 48px;
        }
        h2 {
          font-size: 24px;
          line-height: 36px;
        }
        h3 {
          font-size: 18px;
          line-height: 27px;
        }
        h4 {
          font-size: 16px;
          line-height: 24px;
        }
      `
          : ''
      }
      bg="#fff"
      // Arbitrary HTML (e.g. tables) shouldn't break the surrounding layout —
      // keep it within the parent width and scroll horizontally if it overflows.
      maxW="100%"
      overflowX="auto"
      className={editorStyle ? 'editor-style' : ''}
      {...props}
    >
      <Interweave content={htmlString} transform={hydrateScorecardTable} />
    </Box>
  );
};
